import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { Section } from './Shared';
const faqs = [{
  q: '¿Sirve si recién empiezo con cosmética natural?',
  a: 'Especialmente si recién empezás. El pack te da toda la estructura desde el primer día: recetarios, costos, branding y estrategia de venta. No tenés que esperar años para profesionalizarte. Muchas emprendedoras lo usan desde la primera semana.'
}, {
  q: '¿Cómo recibo el material?',
  a: '100% digital. Después de la compra por Mercado Pago recibís un email con el acceso inmediato a todos los archivos PDF. Podés descargarlos, imprimirlos o usarlos en tablet. Acceso de por vida.'
}, {
  q: '¿Necesito imprimirlo todo?',
  a: 'No. Muchas emprendedoras imprimen solo lo que usan frecuentemente. Otras guardan los PDF en el teléfono. Vos decidís cómo usarlo según tu preferencia.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. Garantía de 7 días sin preguntas. Si en los primeros 7 días considerás que no vale la pena, te reembolsamos el 100%. Pero el 99% de quienes acceden lo mantienen porque ven el valor inmediatamente.'
}, {
  q: '¿Qué pasa después de los 7 días?',
  a: 'Tenés acceso de por vida. Si hacemos actualizaciones en el contenido, las recibís automáticamente. No hay cuota mensual, no hay sorpresas. Pagás una sola vez y es tuyo.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="max-w-3xl" data-id="element-82" data-mp="16pif4r9ffiia">
      <div className="mb-10 text-center" data-id="element-83" data-mp="rz2sr959y4ij">
        <h2 className="flex justify-center font-serif text-2xl font-bold text-brand-taupe md:text-4xl" data-id="element-84" data-mp="s0431begumz7">
          <span className="mr-3" data-id="element-85" data-mp="wyxjncp1uu3l">❓</span>LO QUE MÁS NOS PREGUNTAN
        </h2>
      </div>
      <div className="space-y-4" data-id="element-86" data-mp="izfpehsziomu">
        {faqs.map((faq, index) => <div key={faq.q} className="paper-panel overflow-hidden rounded-2xl border-l-4 border-l-brand-gold" data-id="element-87" data-mp="mzq54m6kwtew" data-mpi={index}>
            <button type="button" aria-expanded={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} className="flex w-full items-center justify-between px-6 py-5 text-left transition-colors duration-150 ease-out hover:bg-brand-parchment focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-gold" data-id="element-88" data-mp="2pn5afjt4lmkq">
              <span className="pr-8 text-sm font-semibold text-brand-taupe md:text-base" data-id="element-89" data-mp="38kg66ufjtxvf">{faq.q}</span>
              <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brand-goldDark transition-transform duration-200 ease-out ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-90" data-mp="33ng1amufr15w" />
            </button>
            <AnimatePresence initial={false} data-id="element-91" data-mp="2ul6otrflwxpv">
              {openIndex === index && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.22,
            ease: [0.23, 1, 0.32, 1]
          }} data-id="element-92" data-mp="1n8xxpu6llv0p">
                  <p className="border-t border-brand-taupe/10 bg-white px-6 py-4 text-sm leading-relaxed text-brand-textLight md:text-base" data-id="element-93" data-mp="2r5izlhx5pi0">
                    {faq.a}
                  </p>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </Section>;
}